<template>
  <a-card class="card" title="数据看板">
    <time-bar ref="timeTeam" :data-picker="false" @change="getOverviewData"></time-bar>
    <a-row type="flex" :gutter="20">
      <a-col span="6" :xxl="{span:4}">
        <div class="box t1">
          <p>{{viewTimeText}}新增发布职位</p>
          <p>{{job_count.toFixed(0)}}</p>
        </div>
      </a-col>
      <a-col span="6" :xxl="{span:4}">
        <div class="box t2">
          <p>{{viewTimeText}}新增简历上传</p>
          <p>{{resume_count.toFixed(0)}}</p>
        </div>
      </a-col>
      <a-col span="6" :xxl="{span:4}">
        <div class="box t3">
          <p>{{viewTimeText}}新增做单数</p>
          <p>{{post_count.toFixed(0)}}</p>
        </div>
      </a-col>
      <a-col span="6" :xxl="{span:4}">
        <div class="box t4">
          <p>{{viewTimeText}}新增签约猎头</p>
          <p>{{hunter_count.toFixed(0)}}</p>
        </div>
      </a-col>
    </a-row>
    <a-row type="flex" :gutter="80">
      <a-col span="20" :xxl="{span: 11}">
        <time-bar
          ref="jobTimeBar"
          :data-picker="false"
          :time-arr="timeArr"
          @change="getJobData"
          style="margin-top:80px"
        ></time-bar>
        <div ref="jobBoard" style="height:400px;margin-top:25px"></div>
      </a-col>
      <a-col span="20" :xxl="{span: 11}">
        <time-bar
          ref="orderTimeBar"
          :data-picker="false"
          :time-arr="timeArr"
          @change="getOrderData"
          style="margin-top:80px"
        ></time-bar>
        <div ref="orderBoard" style="height:400px;margin-top:25px"></div>
      </a-col>
    </a-row>
  </a-card>
</template>

<script>
import moment from "moment";
import Echart from "echarts";
import { Tween } from "@createjs/tweenjs";
import TimeBar from "@/components/time-bar.component";
import Api from "@/api";
export default {
  name: "DataBoard",
  components: { TimeBar },
  data() {
    return {
      timeArr: [
        {
          key: 0,
          text: "过去7天",
          value: [
            moment()
              .subtract(7, "days")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ]
        },
        {
          key: 1,
          text: "过去一月",
          value: [
            moment()
              .subtract(1, "months")
              .format("YYYY-MM-DD"),
            moment().format("YYYY-MM-DD")
          ]
        }
      ],
      job_chart: undefined,
      order_chart: undefined,
      viewTimeText: "",
      hunter_count: 0,
      job_count: 0,
      post_count: 0,
      resume_count: 0
    };
  },
  methods: {
    async getOverviewData(payload) {
      try {
        let response = await Api.dashboard.dataView({
          created_start: payload.value[0],
          created_end: payload.value[1]
        });
        this.viewTimeText = payload.text;
        Tween.get(this).to({ ...response }, 500);
      } catch (e) {}
    },
    async getJobData(payload) {
      try {
        this.job_chart.showLoading();
        let { list } = await Api.dashboard.jobNew({
          created_start: payload.value[0],
          created_end: payload.value[1]
        });
        this.job_chart.hideLoading();
        if (list.length > 7) {
          list.forEach(item => (item[0] = moment(item[0]).format("MM-DD")));
        }
        this.job_chart.setOption({
          title: {
            text: "职位新增"
          },
          tooltip: {
            trigger: "axis",
            formatter(item) {
              return `${item[0].name}<br>新增职位：${item[0].value}`;
            }
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list.map(item => item[0])
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              type: "line",
              markPoint: {
                symbol: "pin",
                symbolSize: 40,
                data: [
                  { type: "max", name: "最大值" },
                  { type: "min", name: "最小值" }
                ]
              },
              markLine: {
                data: [{ type: "average", name: "平均值" }]
              },
              data: list.map(item => item[1])
            }
          ]
        });
      } catch (e) {}
    },
    async getOrderData(payload) {
      try {
        this.order_chart.showLoading();
        let { list } = await Api.dashboard.orderNew({
          created_start: payload.value[0],
          created_end: payload.value[1]
        });
        this.order_chart.hideLoading();
        if (list.length > 7) {
          list.forEach(item => (item[0] = moment(item[0]).format("MM-DD")));
        }
        this.order_chart.setOption({
          color: "#00a2eb",
          title: {
            text: "订单新增"
          },
          tooltip: {
            trigger: "axis",
            formatter(item) {
              return `${item[0].name}<br>新增订单：${item[0].value}`;
            }
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: list.map(item => item[0])
          },
          yAxis: {
            type: "value"
          },
          series: [
            {
              type: "line",
              markPoint: {
                symbol: "pin",
                symbolSize: 40,
                data: [
                  { type: "max", name: "最大值" },
                  { type: "min", name: "最小值" }
                ]
              },
              markLine: {
                data: [{ type: "average", name: "平均值" }]
              },
              data: list.map(item => item[1])
            }
          ]
        });
      } catch (e) {}
    },
    initChart() {
      this.job_chart = Echart.init(this.$refs.jobBoard);
      this.order_chart = Echart.init(this.$refs.orderBoard);
    },
    updataChart(data) {
      // this.chart.setOption({
      //   dataset: data
      // });
    }
  },
  mounted() {
    this.initChart();
    this.$refs.timeTeam.init();
    this.$refs.jobTimeBar.init();
    this.$refs.orderTimeBar.init();
  }
};
</script>

<style scoped lang="scss">
.box {
  margin-top: 40px;
  padding: 25px 0 5px;
  color: #fff;
  text-align: center;
  border-radius: 5px;
  p {
    font-size: 16px;
    font-weight: bold;
    &:last-child {
      font-size: 32px;
    }
  }
  &.t1 {
    background: #00a2eb;
  }
  &.t2 {
    background: #f3a719;
  }

  &.t3 {
    background: #2e5efd;
  }
  &.t4 {
    background: #ff5405;
  }
}
</style>
